import { render, staticRenderFns } from "./FroalaEditor.vue?vue&type=template&id=10265d7e&"
import script from "./FroalaEditor.vue?vue&type=script&lang=js&"
export * from "./FroalaEditor.vue?vue&type=script&lang=js&"
import style0 from "./FroalaEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports